<template>
  <el-dialog title="测试发送" @close="close" :visible="true" width="650px" style="min-width: 1100px">
    <div class="dialog-wrapper" v-loading="loading">
      <div class="item">
        <span >短信测试：</span>
        <el-select v-model="mediaTestMobilesList" multiple collapse-tags placeholder="请选择"
          style="width: 264px;vertical-align: top;" >
          <el-option v-for="item in testOptions" :key="item" :label="item"
            :value="item"></el-option>
        </el-select>
        <el-button class="record" style="margin-right: 0px;" @click="smsDialogs = true" >短信记录</el-button>
        <el-button class="record1" @click="changeDialogShow = true">修改测试手机号</el-button>
      </div>
      <div class="info">
        <i class="el-icon-warning warning-icon"></i>
        <p>1.短信测试号码为申请签名时报备的号码,且发送测试短信不受频控限制。</p>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button showDialog="showDialog" style="width: 96px" @click="close">取消</el-button>
      <el-button @click="submit" type="primary" style="width: 96px">发送</el-button>
    </span>
    <!-- 短信记录 -->
    <sms-template :isMedia="isMedia" :isCard="type" :smsDialog="smsDialogs" v-if="smsDialogs" @transferName="smsDialogs = false"
      @close="smsDialogs = false">
    </sms-template>
    <change-test-number 
      v-if="changeDialogShow"
      @close="changeDialogShow = false" 
      @confirm="changeNumber"
      :testMobiles="testMobiles"
      :id="textPhoneId">
    </change-test-number>
    <sendTestMediaConfirm 
      v-if="sendTestMediaConfirmShow && !type"
      @close="sendTestMediaConfirmShow = false" 
      @confirm="confirmSend"
      :source="4"
      :mediaTestMobilesList="mediaTestMobilesList"
      :id="id"
      :mediaTemplateId="mediaTemplateId">
    </sendTestMediaConfirm>
    <sendTestCardConfirm 
      v-if="sendTestMediaConfirmShow && type"
      @close="sendTestMediaConfirmShow = false" 
      @confirm="sendTestMediaConfirmShow = false"
      :source="4"
      :mediaTestMobilesList="mediaTestMobilesList"
      :title="content"
      :mediaTemplateId="mediaTemplateId">
    </sendTestCardConfirm>
  </el-dialog>
</template>

<script>
import smsTemplate from "@/components/sms-templates-x.vue";
import changeTestNumber from "./changeTestNumber";
import sendTestMediaConfirm from './sendTestMediaConfirm'
import sendTestCardConfirm from './sendTestCardConfirm';
import {
  preCommit,
  getValidSmsTestMobiles,
  testMedia
} from "@/api/smsSend";
import { getSmsMediaTemplateDetail } from "@/api/smsTemplates";
export default {
name: '' ,
components: {
  smsTemplate,
  changeTestNumber,
  sendTestMediaConfirm,
  sendTestCardConfirm
},
props:{
  id:{
    type: String | Number,
    default: "",
  },
  mediaTemplateId:{
    type: String | Number,
    default: "",
  },
  type:{
    type:Boolean | Number,
    default: false
  },
  content:{
    type: String | Number,
    default: "",
  }
},
data() {
return {
  mediaTestMobilesList:[],
  testOptions:[],
  testMobiles:'',
  textPhoneId:'',
  smsDialogs:false,
  loading:false,
  changeDialogShow:false,
  sendTestMediaConfirmShow:false,
}
},
computed: {
  isMedia(){
    return !this.type
  }
},
created() {

},
mounted() {
  this.getPhoneList();
},
methods: {
  close(){
    this.$emit('close');
  },
  submit(){
    if(this.mediaTestMobilesList && this.mediaTestMobilesList.length > 0){
      this.sendTestMediaConfirmShow = true;
    }else{
      this.$message.warning('请输入正确的手机号！');
      return 
    }
  },
  confirmSend(){
    this.sendTestMediaConfirmShow = false;
    this.$emit('close');
  },
  getPhoneList(){
    this.loading = true
    this.mediaTestMobilesList = []
    getValidSmsTestMobiles().then(res=>{
      this.loading = false
      if(res.code == 1){
        this.testOptions = res.data.smsTestMobiles
        this.testMobiles = res.data.smsTestMobiles.join(',')
        this.textPhoneId = res.data.id
      }else{
        this.$message.error(res.message)
      }
    })
  },
  changeNumber(){
    this.changeDialogShow = false;
    this.getPhoneList();
  }
}
}
</script>
<style lang='scss' scoped>
.info {
  // min-width: 900px;
  margin-top: 12px;
  line-height: 22px;
  font-size: 13px;
  color: #999;
  background: #FFFAEE;
  padding: 10px;
  color: #333;
  position: relative;
  margin-left:70px;
  border-radius:4px;
  p {
    margin: 0px;
    line-height: 24px;
    padding-left: 18px;
  }

  .warning-icon {
    color: #ffb95e;
    font-size: 16px;
    position: absolute;
    left: 10px;
    top: 14px;
  }
}
.record {
  margin: 0 24px 0 8px;
  color: #333333;
  font-size: 14px;
  border-radius: 3px;
  border: 1px solid #cccccc;
  background-color: #fff;

  &:hover {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }

  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}

.record1 {
  color: #fe4d45;
  border: 1px solid #fe4d45;
  background-color: #fff4f4;
  font-size: 14px;
  border-radius: 3px;
  width: 114px;
}
</style>